import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';
import store from './config/store';
import App from './App';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import * as serviceWorker from './serviceWorker';
import history from './utils/history';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} basename="/login">
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
